import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    token: localStorage.getItem("accessToken") || "",
    successMessage: "",
    status: "",
    search: "",
    isLoading: true,
    shareBaseUrl: "web.idlc.com/share/",
    storyShareBaseUrl: "web.idlc.com/story/share/",
    csrShareBaseUrl: "web.idlc.com/csr/share/",
    favourite: [],
    favouriteRouteTitle: []
  },
  getters: {
    serach: state => {
      return state.search;
    }
  },

  mutations: {
    auth_success(state, token) {
      (state.status = "success"), (state.token = token);
    },
    updateSearch: (state, payload) => {
      state.search = payload;
    }
  },

  actions: {
    submitContactForm({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("contact-us", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },

    submitComplaint({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("post-feedback-complaint", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },

    submitForHomeLoan({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("apply-loan", payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },
    updateSearch({ commit }, payload) {
      commit("updateSearch", payload);
    },
    submitAppliedResumeForm({ commit }, payload) {
      console.log("fromStore");
      return new Promise((resolve, reject) => {
        axios
          .post("applied-resume", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },

    submitDepositForm({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("post-dps", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },
    submitForSME({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("sme-loan-applied", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },

    submitAfterEligibilityChecked({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("post-home-loan-eligible", payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },

    investorInformationSubmit({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("investor-relation-form", payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(error);
          });
      });
    },
    async leadSubmission({ commit }, payload) {
      console.log(payload);
      try {
        // 1️⃣ Login and get token
        const token = await fetch(
          "https://apps.idlc.com/ExternalReferralAppApi/api/Auth/login",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              username: "IdlcReferralApp",
              password: "Idlc@03Ref#app@25"
            })
          }
        )
          .then(res => res.json())
          .then(res => res.Data.Token);

        if (!token) {
          throw new Error("Failed to retrieve token");
        }

        // 2️⃣ Submit referral with token
        const response = await fetch(
          "https://apps.idlc.com/ExternalReferralAppAPI/api/Referral/create/referral",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
          }
        ).then(res => res.text());

        return response;
      } catch (error) {
        console.error("leadSubmission error:", error);
        throw error;
      }
    }

    // leadSubmission({ commit }, payload) {
    //   const token = new Promise((resolve, reject) => {
    //     const myHeaders = new Headers();
    //     myHeaders.append("Content-Type", "application/json");

    //     const raw = JSON.stringify({
    //       username: "IdlcReferralApp",
    //       password: "Idlc@03Ref#app@25"
    //     });
    //     const requestOptions = {
    //       method: "POST",
    //       headers: myHeaders,
    //       body: raw,
    //       redirect: "follow"
    //     };
    //     fetch(
    //       "https://apps.idlc.com/ExternalReferralAppApi/api/Auth/login",
    //       requestOptions
    //     )
    //       .then(res => res.json())
    //       .then(res => resolve(res.Data.Token))
    //       .catch(err => reject(err));
    //   });
    //   console.log(token);
    //   return new Promise((resolve, reject) => {
    //     const myHeaders = new Headers();
    //     myHeaders.append("Content-Type", "application/json");
    //     myHeaders.append("Authorization", token);
    //     const requestOptions = {
    //       method: "POST",
    //       headers: myHeaders,
    //       body: payload,
    //       redirect: "follow"
    //     };
    //     fetch(
    //       "https://apps.idlc.com/ExternalReferralAppAPI/api/Referral/create/referral",
    //       requestOptions
    //     )
    //       .then(response => response.text())
    //       .then(result => resolve(result))
    //       .catch(error => reject(error));
    //   });
    // }
  },

  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/store.js